<div class="container-fluid" >

    <!-- Header -->
    <div class="row align-items-center mb-3">
        <div class="col-md-6">
            <h2 class="fw-bold mb-0">{{l('ProductMovements')}}</h2>
        </div>

        <div class="col-md-6 text-md-end mt-2 mt-md-0">
            <button pButton
                    icon="pi pi-clear"
                    label="CLEAR"
                    class="btn btn-secondary btn-sm me-2"
                    (click)="clear()">
            </button>

            <button pButton
                    icon="pi pi-refresh"
                    label="REFRESH"
                    class="btn btn-primary btn-sm me-2"
                    (click)="getDetails()">
            </button>

            <!--<button pButton
                    icon="pi pi-file-excel"
                    label="EXPORT TO EXCEL"
                    class="btn btn-danger btn-sm"
                    (click)="exportExcel()">
            </button>-->
        </div>
    </div>

    <!-- Card -->
    <p-card class="shadow-sm border-0">

        <!-- Filters Row -->
        <div class="row g-3">

            <!-- Date Range -->
            <div class="col-md-4 col-sm-12">
                <div class="form-group">
                    <label class="form-label mb-0 fw-semibold">Date range</label>
                    <p-calendar [(ngModel)]="this.dateRange"
                                selectionMode="range"
                                dateFormat="dd/mm/yy"
                                inputStyleClass="form-control w-100"
                                appendTo="body"
                                style="width: 100%">
                    </p-calendar>
                </div>
            </div>

            <!-- Location -->
            <div class="col-md-4 col-sm-12">
                <div class="form-group">
                    <label class="form-label fw-semibold">Location</label>
                    <p-multiSelect [options]="locations"
                                   optionLabel="displayName"
                                   display="chip"
                                   [(ngModel)]="selectedLocations"
                                   appendTo="body"
                                   style="width: 100%"
                                   class="w-100">
                    </p-multiSelect>
                </div>
            </div>

            <!-- Accounts -->
            <div class="col-md-12">
                <div class="form-group">
                    <label for="ProductName">{{ l('ProductName') }}</label>
                    <app-search-product (productEvent)="getProduct($event)" [productSelectedItem]="productSelectedItem"> </app-search-product>
                </div>
            </div>
        </div>
       
        <!-- Summary -->
        <div class="row" *ngIf="primengTableHelper.isLoading">
            <div *ngFor="let item of products">
                <div class="row" style="margin-top:20px;" *ngIf="item.products.length > 0">
                    <div class="col-xs-12 text-center">
                        <h4 class="no-margin margin-bottom-10"><b class="ng-binding">{{item.productCode}} - {{item.productName}}</b></h4>
                        <h6 class="margin-bottom-5"><b class="ng-binding">{{l('ProductCode')}} : {{item.productCode}}</b></h6>
                    </div>
                    <div class="col-6 text-center">
                        <h6 class="margin-top-15 text-danger"><b>{{l('Opening')}} : <span class="font-red">{{ item.products[0].prevQtyOnHand }}</span></b></h6>
                    </div>
                    <div class="col-6 text-center">
                        <h6 class="margin-top-15 text-danger"><b>{{l('Closing')}} : <span class="font-red">{{ item.products[item.products.length - 1].qtyOnHand }}</span></b></h6>
                    </div>

                </div>
                <!-- Table -->
                <table class="table table-bordered table-hover" style="margin-top:20px" *ngIf="item.products.length > 0">
                    <thead>
                        <tr>
                            <th>{{ l('Location') }}</th>
                            <th>{{ l('Module') }}</th>
                            <th>{{ l('TransactionNo') }}</th>
                            <th>{{ l('User') }}</th>
                            <th>{{ l('Date') }}</th>
                            <th>{{ l('Remarks') }}</th>
                            <th class="text-end">{{ l('AdjustQty') }}</th>
                            <th class="text-end">{{l('QtyOnHand')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let pro of item.products">
                            <td>{{pro.locationCode}}</td>
                            <td>{{ l(module[pro.module]) }} </td>
                            <td>{{pro.transactionNo}}</td>
                            <td>{{pro.createdBy}}</td>
                            <td>{{pro.creationTime}}</td>
                            <td>{{pro.remarks}}</td>
                            <td class="text-end">{{pro.adjustQty}}</td>
                            <td class="text-end">{{pro.qtyOnHand}}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </p-card>
</div>
